import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "@/pages/home/components/Hero";
import LearnSection from "@/pages/home/components/LearnSection";
import TransferPath from "@/pages/home/components/TransferPath";
import ImportantNotes from "@/pages/home/components/ImportantNotes";
import OperatorAbout from "@/pages/home/components/OperatorAbout";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const target = document.getElementById(hash.replace("#", ""));
    if (!target) return;

    const wantsReducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: wantsReducedMotion ? "auto" : "smooth",
        block: "start",
      });
    });
  }, [hash]);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <Hero />
        <LearnSection />
        <TransferPath />
        <ImportantNotes />
        <OperatorAbout />
        <ContactSection />
      </main>
      <SiteFooter />
    </div>
  );
}